import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Telehealth by SimplePractice\" separator=\" - \"}}\n\n{{outlet}}\n",{ moduleName: "frontend/templates/application.hbs" })